import isCreditCard from "validator/lib/isCreditCard";
export function forbiddenCreditCardRule() {
    return function (input) {
        var stringOfNumber = extractNumber(input);
        return (!isCreditCard(toHankaku(stringOfNumber)) ||
            "クレジットカード番号を入力しないでください");
    };
}
function extractNumber(str) {
    var charsOfNumber = str.match(/[0-9０-９]+/g);
    return charsOfNumber ? charsOfNumber.join("") : "";
}
function toHankaku(str) {
    return str.replace(/[０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
}
//# sourceMappingURL=forbidden-credit-card.js.map